import React from 'react';
import { ContentTemplate, TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';

import { ResultListing } from '../../../modules/result/@candidate';

const ResultList = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('exam->>ResultListing.My Examinations')} />

      <ContentTemplate type="full" continuous transparent>
        <ResultListing userRole="candidate" header={t('exam->>ResultListing.Exam Results')} />
      </ContentTemplate>
    </>
  );
};

export default ResultList;
